<template>
  <div id="searchbox">
    <div class="searchbox">
      <input id="inputBox" type="text" v-model="keyword" @keydown="toggleSuggestion" :placeholder=placeholder @focus="$emit('lighton')" @blur="$emit('lightoff')">
      <router-link :to="{name:'search_result', query:{keyword:this.keyword}, params:{page:1}}" id="searchIcon" class="nobrick" :key="this.keyword" ref="resultpage">
        <i class="fa fa-search"></i>
      </router-link>
    </div>
    <div id="SearchSuggestionMenu" class="whiteBG" v-show="this.suggestion.length>0 && this.show">
		  <router-link :to="{name:getResultType(result),params:{id:getResultID(result)}}" target="_blank" v-for="(result, index) in suggestion">
        <div id="SuggestionItemCourse" class="suggestionItem" :class="{divide:index < suggestion.length-1}">

            <div class="itemInfo" v-if="getResultType(result)==='map'">
              <svg width="20px" height="18px" viewBox="0 0 20 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g class="tagIcon" transform="translate(-86.000000, -132.000000)" fill="#32344F" fill-rule="nonzero">
                  <g id="Group-15" transform="translate(40.000000, 130.000000)">
                    <g id="Group-13" transform="translate(46.000000, 2.000000)">
                      <path d="M7.84062834,10.0217887 L5.68728475,10.0217887 C5.2114172,11.3989405 3.83663082,12.2244708 2.43169551,11.9767015 C1.0267602,11.7289323 0.000333649105,10.4799329 0.00104607682,9.01898455 C0.00175924658,7.55803623 1.02940406,6.31008934 2.43458044,6.06376001 C3.83975682,5.81743069 5.21373696,6.64436946 5.68826044,8.02200822 L7.84062834,8.02200822 L11.2204119,2.02266679 L14.3133431,2.02266679 C14.7878666,0.645028036 16.1618467,-0.181910737 17.5670231,0.0644185888 C18.9721995,0.310747914 19.9998443,1.5586948 20.0005571,3.01964312 C20.0012699,4.48059144 18.9748434,5.72959085 17.569908,5.97736009 C16.1649727,6.22512934 14.7901864,5.39959905 14.3143188,4.02244728 L12.3463559,4.02244728 L9.53052012,9.02089856 L12.3473316,14.0213496 L14.3143188,14.0213496 C14.7895143,12.6439542 16.1638978,11.8177195 17.5689538,12.0647688 C18.9740099,12.311818 20.0010461,13.5602914 20.0010461,15.0212399 C20.0010461,16.4821884 18.9740099,17.7306617 17.5689538,17.977711 C16.1638978,18.2247603 14.7895143,17.3985256 14.3143188,16.0211301 L11.2204119,16.0211301 L7.84062834,10.0217887 L7.84062834,10.0217887 Z M17.0745404,14.0213496 C16.5356827,14.0213496 16.0988523,14.4690158 16.0988523,15.0212399 C16.0988523,15.573464 16.5356827,16.0211301 17.0745404,16.0211301 C17.6133981,16.0211301 18.0502285,15.573464 18.0502285,15.0212399 C18.0502285,14.4690158 17.6133981,14.0213496 17.0745404,14.0213496 Z M2.92706315,8.02200822 C2.3882055,8.02200822 1.95137506,8.46967433 1.95137506,9.02189846 C1.95137506,9.5741226 2.3882055,10.0217887 2.92706315,10.0217887 C3.46592081,10.0217887 3.90275125,9.5741226 3.90275125,9.02189846 C3.90275125,8.46967433 3.46592081,8.02200822 2.92706315,8.02200822 L2.92706315,8.02200822 Z M17.0745404,2.02266679 C16.5356827,2.02266679 16.0988523,2.4703329 16.0988523,3.02255704 C16.0988523,3.57478117 16.5356827,4.02244728 17.0745404,4.02244728 C17.6133981,4.02244728 18.0502285,3.57478117 18.0502285,3.02255704 C18.0502285,2.4703329 17.6133981,2.02266679 17.0745404,2.02266679 L17.0745404,2.02266679 Z" id="Shape"></path>
                    </g>
                  </g>
                </g>
              </svg>
              <h6 class="itemName">{{result.name}}<span class="itemNote">Concept<span v-if="result.domain"> | {{result.domain.name}}</span></span></h6>
            </div>

            <div class="itemInfo" v-if="getResultType(result)==='course'">
              <svg width="20px" height="23px" viewBox="0 0 20 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g class="tagIcon" transform="translate(-325.000000, -130.000000)" fill="#32344F" fill-rule="nonzero">
                  <g id="Group-15" transform="translate(89.000000, 130.000000)">
                    <g id="Group-9" transform="translate(236.000000, 0.000000)">
                      <path d="M20,17.7864583 L3.33333333,17.7864583 C2.71975004,17.7865523 2.22239232,18.2839861 2.22239232,18.8975694 C2.22239232,19.5111527 2.71975004,20.0085866 3.33333333,20.0086805 L20,20.0086805 L20,22.2309028 L3.33333333,22.2309028 C1.49238417,22.2309028 0,20.7385186 0,18.8975695 L0,2.23090279 C0,1.64153281 0.234126301,1.07630188 0.650873808,0.659554373 C1.06762131,0.242806861 1.63285223,0.00868054688 2.22222221,0.00868054688 L20,0.00868054688 L20,17.7864583 Z M2.22222221,15.6197917 C2.40222221,15.583125 2.58777776,15.5642361 2.77777779,15.5642361 L17.7777778,15.5642361 L17.7777778,2.23090279 L2.22222221,2.23090279 L2.22222221,15.6197917 Z M14.4444445,7.78645833 L5.55555555,7.78645833 L5.55555555,5.56423612 L14.4444445,5.56423612 L14.4444445,7.78645833 Z" id="Shape"></path>
                    </g>
                  </g>
                </g>
              </svg>
              <h6 class="itemName">{{result.name}}<span class="itemNote"><span v-if="result.provider">{{result.provider}}</span><span v-if="result.provider&&result.platform"> | </span><span v-if="result.platform">via {{result.platform}}</span></span></h6>
            </div>

          <!--
          <div class="rate">
            <div class="star"></div>
            <p class="score">{{score}}<span class="numberOfViews note"> ({{view}}) views </span></p>
          </div>
          -->
        </div>
      </router-link>
	  </div>
  </div>
</template>

<script>
import {getSuggestedCourse, getSuggestedConcept} from "../../api/api";

export default {
  name: 'Searchbox',
  props:{
    placeholder:String
  },
  data(){
    return{
      keyword:"",
      suggestion: [],
      show:false
    }
  },
  watch: {
      //return a list of concepts and courses in suggest dropdown
    keyword: function() {
      getSuggestedConcept({'search':this.keyword
      }).then((response)=>{
        this.suggestion = response.data.slice(0,3)
        getSuggestedCourse({'search':this.keyword
        }).then((sugg_course)=>{
          this.suggestion = this.suggestion.concat(sugg_course.data.slice(0,3))
        })
      })
    }
  },
  methods: {
    getResultType:function(item){
      if(item.concept_id){
          return 'map'
      }
      else{
          return 'course'
      }
    },
    getResultID:function(item){
        if(item.concept_id){
            return item.concept_id
        }
        else{
            return item.url_object_id
        }
    },
    goToPages:function(){
      this.$router.push({
        name:'search_result',
        query:{
          keyword:this.keyword
        },
        params:{page:1}
      })
    },
    toggleSuggestion: function (event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        this.goToPages()
      } else {
        this.show=true;
      }
    },
    handleClickOutside(evt) {
        if (!this.$el.contains(evt.target)) {
            this.show = false;
        }
    }
  },
  mounted(){
      document.addEventListener("click", this.handleClickOutside);
  }
}
</script>



// WEBPACK FOOTER //
// src/view/General/Searchbox.vue